import * as Styled from "./styled";

const FlexContainer = ({ children, ...props }: Styled.FlexContainerProps) => {
  return <Styled.FlexContainer {...props}>{children}</Styled.FlexContainer>;
};

export default FlexContainer;
